import {
  notEmptyString,
} from '@populateui/utils';
import {
  formatDate,
} from 'utils/date';
import {
  ClaimLogEntryViewDTO,
} from 'dtos';
import compact from 'lodash/compact';

export type ActivityDetailItem = {
  label?: string;
  value: string;
  copyText?: string;
};

export function getActivityDetail(entry: ClaimLogEntryViewDTO): ActivityDetailItem[] {
  const parts: ActivityDetailItem[] = [];
  const effectiveDate = entry.effectiveDate ?? '';
  const eobNumber = entry.eobNumber ?? '';
  const payerClaimNumber = entry.payerClaimNumber ?? '';
  const reportedBy = entry.reportedBy ?? '';

  if (notEmptyString(effectiveDate)) {
    parts.push({
      label: 'Effective',
      value: formatDate(effectiveDate),
    });
  }
  if (notEmptyString(eobNumber)) {
    parts.push({
      label: 'EOB number',
      value: eobNumber,
      copyText: eobNumber,
    });
  }
  if (notEmptyString(payerClaimNumber)) {
    parts.push({
      label: 'Payer claim number',
      value: payerClaimNumber,
      copyText: payerClaimNumber,
    });
  }
  if (notEmptyString(reportedBy)) {
    parts.push({
      label: 'Reported by',
      value: reportedBy,
    });
  }
  if (notEmptyString(entry.sentTo) || notEmptyString(entry.route)) {
    parts.push({
      label: 'Sent to',
      value: compact([entry.sentTo, entry.route]).join(' · '),
    });
  }

  return parts;
}
